import { render, staticRenderFns } from "./send_blank_exam.vue?vue&type=template&id=000f542e&scoped=true"
import script from "./send_blank_exam.vue?vue&type=script&lang=js"
export * from "./send_blank_exam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000f542e",
  null
  
)

export default component.exports